// src/services/api/apiWrapper.js
import { toast } from 'react-toastify';

export const apiHandler = async (apiCall, successHandler, errorHandler = null) => {
  try {
    const response = await apiCall();
    
    if (response?.isSuccess !== false) {
      return successHandler(response);
    }
    
    const errorMsg = response?.message || 'Request failed';
    toast.error(errorMsg);
    throw new Error(errorMsg);
    
  } catch (error) {
    console.error('API Error:', error);
    
    if (errorHandler) {
      errorHandler(error);
    } else {
      const userMessage = error.response?.data?.message || 
                       error.message || 
                       'An unexpected error occurred';
      toast.error(userMessage);
    }
    
    throw error;
  }
};